import React from 'react';
import { Btn, H6, Image } from '../../../../AbstractElements';
import { Link } from 'react-router-dom';


const style = {
  width: 40,
  height: 40,
};
const style2 = { width: 60, fontSize: 14, padding: 4 };

export const productData = [
  {
   
    Details: (
      <div>
        <H6>Tefo Bontsokwane</H6>
        <span>Leadership Transformation Programme Application</span>
      </div>
    ),
    amount: '5389462',
    stock: <div className='font-success'>Reviewed by HR</div>,
    start_date: '2022/4/19',
    action: (
      <div>
        {' '}
        &nbsp;&nbsp;
        <span>
		     <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp`}>
                    
          <Btn attrBtn={{ style: style2, color: 'success', className: 'btn btn-xs', type: 'button' }}>Review </Btn>
		  
         </Link>
        </span>
      </div>
    ),
  },
  
];


export const productColumns = [
  
  {
    name: 'Application Details',
    selector: (row) => row.Details,
    sortable: true,
    center: false,
    wrap: true,
    minWidth: '400px',
  },
  {
    name: 'Employee ID',
    selector: (row) => row.amount,
    sortable: true,
    center: true,
    minWidth: '100px',
    maxWidth: '150px',
  },
  {
    name: 'Status',
    selector: (row) => row.stock,
    sortable: true,
    center: true,
    minWidth: '120px',
    maxWidth: '150px',
  },
  {
    name: 'Date',
    selector: (row) => row.start_date,
    sortable: true,
    center: true,
    minWidth: '120px',
    maxWidth: '150px',
  },
  {
    name: 'Action',
    selector: (row) => row.action,
    sortable: true,
    center: true,
    minWidth: '160px',
    maxWidth: '160px',
  },
];
